import React from 'react';
import { Mail } from 'lucide-react';

const Advertise = () => {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-8 md:px-12 py-16 sm:py-24">
        <h1 className="text-5xl sm:text-6xl tracking-tight leading-none font-black mb-8" data-testid="advertise-title">
          Advertise With Us
        </h1>
        <div className="prose prose-lg max-w-none">
          <p className="text-base sm:text-lg leading-relaxed mb-6">
            Reach thousands of automotive enthusiasts and Pune locals through The Pune Perspective. Our platform 
            offers unique opportunities to connect with a highly engaged audience interested in cars, industry trends, 
            and local news.
          </p>

          <h2 className="text-3xl sm:text-4xl tracking-tight leading-tight font-bold mt-12 mb-6">
            Why Advertise With Us?
          </h2>
          <ul className="list-disc pl-6 space-y-2 text-base sm:text-lg leading-relaxed mb-6">
            <li><strong>Targeted Audience:</strong> Automotive enthusiasts, industry professionals, and local readers</li>
            <li><strong>High Engagement:</strong> Active community with regular readership</li>
            <li><strong>Local Focus:</strong> Strong presence in Pune and Maharashtra region</li>
            <li><strong>Industry Expertise:</strong> Trusted voice in automotive journalism</li>
            <li><strong>Multiple Formats:</strong> Banner ads, sponsored content, newsletter features</li>
          </ul>

          <h2 className="text-3xl sm:text-4xl tracking-tight leading-tight font-bold mt-12 mb-6">
            Advertising Options
          </h2>
          <div className="space-y-6 mb-12">
            <div className="border border-border p-6">
              <h3 className="text-xl font-bold mb-3">Display Advertising</h3>
              <p className="text-muted-foreground">Banner ads, sidebar placements, and homepage features</p>
            </div>
            <div className="border border-border p-6">
              <h3 className="text-xl font-bold mb-3">Sponsored Content</h3>
              <p className="text-muted-foreground">Native articles and editorial partnerships</p>
            </div>
            <div className="border border-border p-6">
              <h3 className="text-xl font-bold mb-3">Newsletter Sponsorship</h3>
              <p className="text-muted-foreground">Featured placement in our weekly newsletter</p>
            </div>
            <div className="border border-border p-6">
              <h3 className="text-xl font-bold mb-3">Event Coverage</h3>
              <p className="text-muted-foreground">Exclusive coverage of launches and auto events</p>
            </div>
          </div>

          <div className="bg-secondary p-8 border border-border mt-12">
            <h2 className="text-2xl font-bold mb-4">Get Started</h2>
            <p className="mb-6">
              Interested in advertising with us? Let's discuss how we can help you reach your marketing goals.
            </p>
            <a
              href="mailto:onlyone610@gmail.com"
              className="inline-flex items-center space-x-2 px-6 py-3 bg-primary text-primary-foreground font-bold hover:bg-primary/90 transition-colors duration-300"
              data-testid="advertise-contact-btn"
            >
              <Mail className="w-5 h-5" />
              <span>Contact Us</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Advertise;
